import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    getInputData, 
    getPersonalDocuments, 
    getPersonalDocumentsArray, 
    getSelectedFile, 
    setSelectedFile as setSelectedFileReducer, 
    setNextFile as setNextFileReducer, 
    getSelectedActualControl, 
    getNextFile
} from '../store/forms';
import { ciRequired as ciRequiredSelector, licenseRequired as licenseRequiredSelector} from '../store/reserve';

const usePersonalDocuments = () => {
    const dispatch = useDispatch();
    const setSelectedFile = (value) => dispatch(setSelectedFileReducer(value));
    const setNextFile = (value) => dispatch(setNextFileReducer(value));

    const adelante = 'Adelante';
	const posterior = 'Posterior';
	const cedula = 'cedula';
	const licencia = 'licencia';
  
    
    const selectedFile = useSelector(getSelectedFile);
    const personalDocumentsFormArray = useSelector(getPersonalDocumentsArray);

    const actualControl = useSelector(getSelectedActualControl);
	const { document, documentType, title } = actualControl;
    
	const ciRequired = useSelector(ciRequiredSelector);
	const licenseRequired = useSelector(licenseRequiredSelector);
    
    const personalDocumentsFileArray = personalDocumentsFormArray.filter((pd) => pd.type === 'file');
    const filesEffect = personalDocumentsFileArray.map((pd) => pd.data);

    

	useEffect(() => {
        const filtered = personalDocumentsFileArray
            .filter((pd) => (pd.data === '' || pd.source !== 'user') && pd.id !== selectedFile)
            .filter((pd) =>  (ciRequired && pd.document === 'cedula') || (licenseRequired && pd.document === 'licencia'));
        if (filtered.length > 0) {
            // Verificar si falta una toma (posterior, adelante) del mismo documento (cedula, licencia)
            const ohterDocumentType = filtered.filter((pd) => pd.document === document);
            if (ohterDocumentType.length > 0) {
                setNextFile(ohterDocumentType[0].id);
            }else{
                setNextFile(filtered[0].id);
            }
        } else {
            setNextFile('');
        }
    }, [filesEffect]); // eslint-disable-line react-hooks/exhaustive-deps

    const nextFile = useSelector(getNextFile);
	return { 
        nextFile,
		personalDocumentsFileArray,
        personalDocumentsFormArray,
        selectedFile,
        setSelectedFile,
        document,
        documentType,
        title,
        keys: {
            adelante,
            posterior,
            cedula,
            licencia
        }
	};
}

export default usePersonalDocuments;
